import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=548fbb3e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fbb3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548fbb3e')) {
      api.createRecord('548fbb3e', component.options)
    } else {
      api.reload('548fbb3e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=548fbb3e&scoped=true&", function () {
      api.rerender('548fbb3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gjq76D6y0TuC/JS/comp/SearchFilterTokens.vue"
export default component.exports